import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const UnauthorizedHandler = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { showToast } = useToast();

  useEffect(() => {
    const handleUnauthorized = () => {
      showToast({
        message: 'Your session expired. Please sign in again.',
        severity: 'error',
        duration: 6000,
      });
      logout();
      navigate('/');
    };

    window.addEventListener('unauthorized', handleUnauthorized);

    return () => {
      window.removeEventListener('unauthorized', handleUnauthorized);
    };
  }, [navigate, logout, showToast]);

  return null;
};

export default UnauthorizedHandler;